import React, { useState } from 'react';
import { Button, Typography } from "@material-ui/core";

function ImageUploader({ onImageSelected }) {
    const [image, setImage] = useState(null);

    const handleChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setImage(URL.createObjectURL(file));
            onImageSelected(file); // Appel vers le parent
        }
    };

    return (
        <div>
            <input
                accept="image/*"
                id="upload-image"
                type="file"
                style={{ display: 'none' }}
                onChange={handleChange}
            />
            <label htmlFor="upload-image">
                <Button variant="contained" component="span">
                    Choisir une image
                </Button>
            </label>

            {image && (
                <div style={{ marginTop: 16 }}>
                    <Typography variant="subtitle1">Aperçu :</Typography>
                    <img src={image} alt="Aperçu" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
            )}
        </div>
    );
}

export default ImageUploader;
